import React, { useState, useCallback } from 'react';
import TopicMode from './TopicMode';
import DateFilter from '../SharedControls/DateFilter';

const TopicModeWithDateFilter = (props) => {
  const [dateFilter, setDateFilter] = useState(null);
  const [isDateFilterVisible, setIsDateFilterVisible] = useState(false);

  const handleDateFilterChange = useCallback((filter) => {
    setDateFilter(filter);
  }, []);

  const toggleDateFilterVisibility = () => {
    setIsDateFilterVisible(prev => !prev);
  };

  return (
    <>
      <TopicMode {...props} dateFilter={dateFilter} />
      <DateFilter
        isVisible={isDateFilterVisible}
        onToggle={toggleDateFilterVisibility}
        onDateFilterChange={handleDateFilterChange}
      />
    </>
  );
};

export default TopicModeWithDateFilter;